import React from "react";
import { Form, Input, Typography } from "antd";
const { Title } = Typography;

export const TitleProjectStep = ({
  value,
  onChange,
  title = "Введіть назву нового проекту та номер 1С замовлення",
  size = "large",
  disabled = false,
  accountNumber = "",
}) => {
  return (
    <div style={{ maxWidth: 520, margin: "0 auto" }}>
      <Title level={4}>{title}</Title>
      <Form.Item
        rules={[
          {
            required: true,
            message: "Вкажіть назву проекту",
          },
        ]}
      >
        <Input
          disabled={disabled}
          value={value}
          onChange={(e) => onChange("title", e.target.value)}
          size={size}
          placeholder={value || "Наприклад: Летичівський комбікормовий завод"}
        />
      </Form.Item>
      <Form.Item
        rules={[
          {
            required: true,
            message: "Вкажіть 1С номер проекту",
          },
        ]}
      >
        <Input
          maxLength={6}
          disabled={disabled}
          value={accountNumber}
          onChange={(e) => onChange("accountNumber", e.target.value)}
          size={size}
          placeholder={accountNumber || "Номер 1С замовлення"}
        />
      </Form.Item>
    </div>
  );
};
